var render = function render(_c,_vm){return _c('p',{staticClass:"heading"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }